<template>
  <div>
    <div v-if="prefijo == enumeraciones.etiquetasDeHTML.Select" class="form-group">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id && (textoCompletoSingular == null && textoCompletoSingular == undefined) && conOpcionDeinstrucciones" :value="tipo.Id">{{tipo.Nombre}} un tipo de {{textoOpcionesSingular}}</option>
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id && (textoCompletoSingular != null && textoCompletoSingular != undefined) && conOpcionDeinstrucciones" :value="tipo.Id">{{ textoCompletoSingular }}</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id && conOpcionDeinstrucciones" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las {{textoOpcionesPlural}}</option>        
        <option v-for="(elemento,index) in elementosCatalogo" :value="elemento.TipoResolucionId" :key="index">{{elemento.Nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'

  export default {
    data() {
      return {
        enumeraciones,
        idDelModelo:null
      }
    },
    props: {            
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      elementosCatalogo: Array,
      textoCompletoSingular: {
        type: String,
        default: null
      },
      conOpcionDeinstrucciones: {
        type: Boolean,
        default: true
      },
      textoOpcionesSingular:String
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elemento seleccionado
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        this.$emit("valorParaElPadre",evento);
      }
    }, 
    mounted(){ 
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
    },
    watch: {
      elementosCatalogo() {
        this.idDelModelo = -1;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/SICPE/Comun/CCatalogoTipoResolucion.vue